export default __webpack_public_path__ + "static/media/sponsor_3.8c6cfdf8.png";